<div class="row wrapper border-bottom page-heading px-0">
  <div class="col-lg-12">
    <div class="header_search header_search_mobile">
      <div class="title-page">Abas</div>
      <div class="content_search">
        <div class="btn-new-group btn-wx" *ngIf="canSave">
          <button class="btn btn-default" type="btn" *ngIf="!ordenacao" (click)="ordenacao = true">Ordenar</button>
          <button class="btn btn-primary" type="btn" *ngIf="ordenacao" (click)="salvarOrdem()">Salvar Ordem</button>
        </div>
        <div class="btn-new-group" *ngIf="canSave">
          <a class="btn btn-primary" type="btn" [routerLink]="novo()">Novo</a>
        </div>
      </div>
    </div>
    <div class="system-table table-container">
      <div class="system-table-conteiner">
        <table cdkDropList (cdkDropListDropped)="drop($event)" [cdkDropListDisabled]="!ordenacao"
          [ngClass]="{'ordenacao': ordenacao}">
          <thead>
            <tr>
              <th class="width5" *ngIf="ordenacao">Ordenação</th>
              <th class="width5">Código</th>
              <th>Nome</th>
              <th class="text-center width5">Ações</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of abasList; let i = index">
              <tr cdkDrag>
                <td class="title text-center" *ngIf="ordenacao">{{ i + 1 }}</td>
                <td class="text-center" [ngClass]="{'title': !ordenacao}">{{ item?.id }}</td>
                <td><span class="title-span">{{ item?.name }}</span></td>
                <td>
                  <div class="btn-icon" *ngIf="canSave">
                    <a class="icon-table" [routerLink]="editar(item?.id)">
                      <img src="assets/images/svgs/editar1.svg" alt="Editar" tooltip="Editar" placement="bottom">
                    </a>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end">
      <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
      </div>
    </div>
  </div>
</div>
<app-loading [loader]="isLoading"></app-loading>